import React from "react";

function HeroContact() {
  return (
    <section className="min-h-[80%] bg-primario flex flex-col justify-center items-center text-center gap-10 px-4 py-[25%] sm:py-[15%]  sm:px-6 lg:px-8">
      <h2 className="text-yellow-1 bg-yellow-1/20 border-2 border-yellow-1 px-3 sm:px-4 py-1 rounded-full font-bold backdrop-blur-sm text-xs sm:text-sm md:text-base">
        Brighton, The Bridge To Your Future
      </h2>
      <h1 className="capitalize text-3xl sm:text-4xl md:text-5xl lg:text-7xl 2xl:text-8xl font-bold w-full sm:w-5/6 md:w-2/3 text-white leading-tight">
        Comienza tu <strong className="text-yellow-1">viaje</strong> hoy
      </h1>
      <p className="text-white font-bold text-base sm:text-lg md:text-xl w-full sm:w-5/6 md:w-2/3">
        Transforma tu futuro profesional y personal dominando el idioma global.
        Completa nuestro formulario y recibe una asesoría personalizada.
      </p>
    </section>
  );
}

export default HeroContact;
